import { Avatar, Card, Dropdown, Menu, Typography } from 'antd'
import React, { FC, ReactElement } from 'react'
import * as s from './styles'
import MenuItem from '../MenuItem'
import { useActorSession } from '../../BusinessLogic'
import './styleOverride.less'

const { Paragraph } = Typography

const ActorSessionMenu: FC = (): JSX.Element => {
  const session = useActorSession()

  if (session === null) {
    return null
  }

  const { user, links, logout } = session

  const DropDownMenu = (): ReactElement => (
    <>
      <Card
        bordered={false}
        style={{ borderRadius: 0 }}
        bodyStyle={{ padding: '16px 16px 0' }}
      >
        <Paragraph>Hi {user?.firstName} 👋</Paragraph>
      </Card>
      <Menu style={{ border: 0 }}>
        <Menu.Divider />
        {links.map(MenuItem)}
        <Menu.Divider />
        <Menu.Item>
          <a onClick={logout.onClick}>
            {logout.title}
          </a>
        </Menu.Item>
      </Menu>
    </>
  )

  return (
    <Dropdown
      overlayStyle={s.dropDown}
      overlay={<DropDownMenu />}
      trigger={['click']}
      placement='bottomRight'
      getPopupContainer={() => document.querySelector('header-app-root header')}
      arrow
    >
      <Avatar src={user.avatar} size='large' style={s.avatar}>
        {user.firstName}
      </Avatar>
    </Dropdown>
  )
}

export default ActorSessionMenu
